import FunctionCategory from 'notebook/tables/excess/FunctionCategory';
import {BASE_AGGREGATION} from 'pipelines/formula/functions/BaseFunctions';

import {AnalysisFunction} from '../FunctionTypes';

export default {
  ...BASE_AGGREGATION,
  category: FunctionCategory.MATH,
  name: 'PRODUCT',
  description:
    'Multiplies all numbers in a single column OR across each row of multiple columns. Single numbers are treated as columns containing only that number.',
  shortDescription: 'Multiplies all values',
} satisfies AnalysisFunction;
